var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cube-query-builder"},[_vm._t("default",null,{"query":_vm.query,"measures":_vm.measures,"dimensions":_vm.dimensions,"segments":_vm.segments,"timeDimensions":_vm.timeDimensions,"filters":_vm.filters,"updateQuery":_vm.updateQuery,"isQueryPresent":_vm.isQueryPresent})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }